var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsPadIcon = function SvgDotsPadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.125 5.25a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0M12 3.375a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75m6.75 0a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75m-13.5 6.75a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75m6.75 0a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75m6.75 0a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75m-13.5 6.75a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75m6.75 0a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75m6.75 0a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75",
    clipRule: "evenodd"
  })));
};
export default SvgDotsPadIcon;